// extracted by mini-css-extract-plugin
export default {"modal":"Loading_modal__WrDsq","content":"Loading_content__N5eZo"};